import React from "react";
import UserMenu from "../components/UserMenu";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";

const OtherReceipt = () => {
  return (
    <div className="flex h-screen">
      <SideMenu />
      <div className="flex-1 flex flex-col">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1">
          {/* Left Side */}
          <div className="flex-1 p-4">
            <div className="p-8 bg-gray-100 min-h-screen">
              <h1 className="text-2xl font-bold text-gray-800 mb-4">
                New Receipt - Other
              </h1>

              <div className="bg-white p-6  space-y-4">
                <div className="flex items-center space-x-6">
                  <div className="flex items-center space-x-6">
                    <div>
                      <b>Date: </b> <span>01/10/2025</span>
                    </div>
                    <div>
                      <b>Vol no: </b> <span>8</span>
                    </div>
                    <div>
                      <b>Serial no: </b> <span>1</span>
                    </div>
                  </div>
                </div>
                {/* Text Inputs */}
                <div className="grid md:grid-cols-2 gap-4 mt-4">
                  <div>
                    <input
                      type="text"
                      className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Applicant Name"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Applicant Type"
                      className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      className="w-full border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="Applicant Fee"
                    />
                  </div>
                </div>

                <div className="flex justify-center space-x-4 mt-6">
                  <button className="bg-blue-400 text-white grid-cols-1 px-6 py-2 rounded hover:bg-blue-700 focus:outline-none">
                    SAVE
                  </button>
                  <button className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700 focus:outline-none">
                    CANCEL
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="w-64 h-full">
            <UserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherReceipt;
